import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { ToastComponent } from '../shared/toast/toast.component';
import { AuthService } from '../services/auth.service';
import { ClientService } from '../services/client.service';
import { Client } from '../shared/models/client.model';
import { ee, clusters, contracts, perPage250, categories } from '../shared/constants';
import { removeTooltipElement, saveFile } from '../shared/functions';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.scss'],
  standalone: false
})
export class ClientsComponent implements OnInit, OnDestroy {
  auth = inject(AuthService);
  private clientService = inject(ClientService);
  toast = inject(ToastComponent);


  isLoading = {
    clients: true,
    stats: true
  };
  isSearching = false;
  clusters = clusters;
  categories = categories;
  contracts = contracts;
  perPage = perPage250;
  page = 0;
  clients: Client[] = [];
  clientAdded = false;
  count = 0;
  canAddClient = false;
  canExportCsv = false;
  // Filters
  name = '';
  cluster = '';
  category = '';
  created_at = '';
  active = '1';
  notes = '';
  contract = '';
  started = '';
  expiration = '';
  autorenewal = '';
  user = ''; // ?
  currentContent = 'clients';
  menuItems = [
    { name: 'Clients', link: 'clients', icon: 'users' },
    { name: '', link: '', icon: '' }, // Workaround to create a separator
    { name: 'Add new', link: 'add-new-client', icon: 'user-plus' },
  ];

  ngOnInit(): void {
    ee.on('changeContent', (data: string) => {
      this.currentContent = data;
      this.clientAdded = false;
    });
    ee.on('getClients', (page?: number) => this.search(page));
    ee.on('clientAdded', (clientAdded: boolean) => this.clientAdded = clientAdded);
    this.canAddClient = this.auth.currentUser.permissions.includes('addClient');
    if (!this.canAddClient) {
      // Show this menu item only to those who can add new guidelines
      this.menuItems = this.menuItems.filter(menu => menu.link !== 'add-new-client');
    }
    this.canExportCsv = this.auth.currentUser.permissions.includes('exportCsv');
    this.search();
  }

  ngOnDestroy(): void {
    ee.off('changeContent', () => {});
    ee.off('getClients', () => {});
    ee.off('clientAdded', () => {});
    removeTooltipElement();
  }

  search(page?: number, csv?: boolean): void {
    this.isLoading.clients = true;
    this.isSearching = true;
    this.page = page || 0;
    const params = {
      name: this.name,
      cluster: this.cluster,
      category: this.category,
      created_at: this.created_at,
      active: this.active,
      notes: this.notes,
      contract: this.contract,
      started: this.started,
      expiration: this.expiration,
      autorenewal: this.autorenewal,
      _users: this.user,
      csv: csv || false,
      page: this.page,
      perPage: this.perPage,
    };
    this.clientService.search(params)
      .pipe(finalize(() => this.isLoading.clients = false))
      .subscribe({
        next: res => {
          if (csv) {
            saveFile(res, 'clients.csv');
          } else {
            this.clients = res.results;
            this.count = res.count;
          }
        },
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

}
